module.exports = __webpack_public_path__ + "static/media/target.068a07bc.svg";